<template>
  <div>
    <upload-document-modal
      ref="uploadDocumentModal"
      :name-document="dataEdit.documentType"
      :data-edit="dataEdit"
      :source-id="dataEdit.sourceId"
      :object-data="objectData"
    />
  </div>
</template>

<script>
import { filesValidateMixinChildActions } from '@/mixins/filesValidateMixin'
import UploadDocumentModal from '../../components/Upload/UploadDocumentModal'

export default {
  name: 'SigConfirmAct',
  components: { UploadDocumentModal },
  mixins: [filesValidateMixinChildActions],
  props: {
    contragent: {
      type: Object,
      default: () => Object(),
    },
  },
  data() {
    return {
      objectData: {},
      dataEdit: {
        sourceModelName: 'contragents',
        sourceId: 0,
        documentType: 'v_sig_confirm_akt',
      },
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'заявка на присоединение к договору',
        childFilesCountProperty: 'countFiles',
      },
    }
  },
  watch: {
    contragent: {
      immediate: true,
      handler(newVal) {
        this.objectData = newVal
        this.dataEdit.sourceId = newVal.id
      },
    },
  },
}
</script>
